import { LoginNotificationComponent } from '../../components/login/AuthNotification';
import {
    useTheme,
    View,
    Heading,
    Text,
    type AuthenticatorProps,
    useAuthenticator,
    Button,
} from '@aws-amplify/ui-react';

type Config = Required<AuthenticatorProps>['components'];

const ResetPasswordDeliveryMessage = () => {
    const { codeDeliveryDetails } = useAuthenticator((context) => [
        context.codeDeliveryDetails,
    ]);
    const destination = codeDeliveryDetails?.Destination;

    if (!destination) return null;

    return (
        <Text>
            <Text
                marginTop="0.5rem"
                as="span"
                display="block"
                fontWeight="bold"
            >
                送信先:{destination}
            </Text>
            に認証コードを送信しました.
        </Text>
    );
};

export const AuthenticatorComponent: Config = {
    Header() {
        const { tokens } = useTheme();
        return <View padding={tokens.space.xxl} />;
    },
    SignIn: {
        Header() {
            const { tokens } = useTheme();
            return (
                <Heading
                    fontSize={tokens.fontSizes.large}
                    marginTop={tokens.space.xl}
                    marginLeft={tokens.space.xl}
                >
                    Waymark Portal ログイン
                </Heading>
            );
        },
        Footer() {
            const { toForgotPassword } = useAuthenticator();

            return (
                <>
                    <View textAlign="center">
                        <Button
                            fontWeight="bold"
                            onClick={toForgotPassword}
                            size="small"
                            variation="link"
                        >
                            パスワードを忘れましたか？
                        </Button>
                    </View>
                    <LoginNotificationComponent />
                </>
            );
        },
    },
    ConfirmSignIn: {
        Header() {
            const { codeDeliveryDetails } = useAuthenticator((context) => [
                context.codeDeliveryDetails,
            ]);
            const destination = codeDeliveryDetails?.Destination;

            return (
                <>
                    <Heading>認証コード入力</Heading>
                    {destination && (
                        <Text>
                            ログインするには、テキストメッセージに記載されたコードを
                            入力してください.
                            <Text
                                marginTop="0.5rem"
                                marginBottom="0.5rem"
                                as="span"
                                display="block"
                                fontWeight="bold"
                            >
                                送信先:{destination}
                            </Text>
                            到着するまでに 1 分ほどかかる場合があります.
                        </Text>
                    )}
                </>
            );
        },
    },
    ForceNewPassword: {
        Header() {
            return <Heading>パスワード再交付</Heading>;
        },
    },
    ForgotPassword: {
        Header() {
            return <Heading>パスワード再交付</Heading>;
        },
    },
    ConfirmResetPassword: {
        Header() {
            return (
                <>
                    <Heading>パスワード再交付</Heading>
                    <ResetPasswordDeliveryMessage />
                </>
            );
        },
    },
};
